import { useState, FormEventHandler } from 'react'
import { Button } from '@stratascratch/ui'

const EMAIL_SUBSCRIPTION_URL =
  'https://api.stratascratch.com/users/subscribe-to-newsletters/'

function SubscriptionWidget() {
  const [showSuccessMessage, setShowSuccessMessage] = useState(false)
  const [isEmailValid, setIsEmailValid] = useState(true)
  const [email, setEmail] = useState('')

  const emailValidation = () => {
    const regex =
      // eslint-disable-next-line
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
    if (email.trim() === '' || regex.test(email) === false) {
      setIsEmailValid(false)
      return false
    }
    setIsEmailValid(true)
    return true
  }

  const handleSubmit: FormEventHandler = (event) => {
    event.preventDefault()
    event.stopPropagation()

    if (!emailValidation()) return

    fetch(EMAIL_SUBSCRIPTION_URL, {
      method: 'POST',
      body: JSON.stringify({ email }),
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.success === true) {
          setShowSuccessMessage(true)
        } else {
          setIsEmailValid(false)
        }
      })
  }

  return (
    <div className="flex flex-col items-stretch gap-2 px-4 sm:items-center">
      {showSuccessMessage ? (
        <p className="text-center text-lg font-bold">
          Thank you! Check your inbox for a message from us.
        </p>
      ) : (
        <>
          <p className="text-center text-lg font-bold">
            Become a data expert. Subscribe to our newsletter.
          </p>
          <form
            className="flex flex-col gap-2 sm:flex-row"
            onSubmit={handleSubmit}
            noValidate
          >
            <input
              name="email"
              type="email"
              placeholder="Enter your email address"
              value={email}
              className="bg-(--bg-color-secondary) text-(--text-color-light) h-11 rounded-full px-6 text-sm sm:min-w-96"
              onChange={(e) => setEmail(e.target.value)}
            />
            <Button as="button" variant="primary" size="small" className="h-11">
              Subscribe
            </Button>
          </form>
          {!isEmailValid && (
            <span className="text-(--color-danger) text-center text-sm">
              Please enter a valid email address.
            </span>
          )}
        </>
      )}
    </div>
  )
}

export default SubscriptionWidget
